module.exports = __webpack_public_path__ + "static/media/img_goldfritz.b208fddf.jpg";